
export const LIST_NOTICE_API = {
  url: `/api/notifications/log/notices`,
  method: 'get',
}
